<!-- advertisement section -->
<div class="abt-section visiting-hours mt-80 mb-40" id="commodity-item">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="abt-bg">
          <img
            src="../assets/images/project/coconutsemihuskthree.jpg"
            alt="im"
          />
          <!-- <a href="https://www.youtube.com/watch?v=DBLlFWYcIGQ" class="video-play-btn popup-youtube"><i class="lni lni-gallery"></i></a> -->
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <h1 class="display-6 text-white mt-5 mb-3">Semi Husked Coconut</h1>
        <table class="table mb-100">
          <tbody>
            <!-- <tr>
            <td>Origin</td>
            <td>West Kalimantan</td>
          </tr> -->
            <tr>
              <td>Color</td>
              <td>Golden-Brown</td>
            </tr>
            <tr>
              <td>Variety</td>
              <td>Matured Coconut</td>
            </tr>
            <tr>
              <td>Weight</td>
              <td>0.7 – 1.2 Kilograms</td>
            </tr>
            <tr>
              <td>Outer Diameter</td>
              <td>35 – 45 cm (13” – 15”)</td>
            </tr>
            <tr>
              <td>Condition</td>
              <td>No sprouts or cracks</td>
            </tr>
            <tr>
              <td>Capacity</td>
              <td>135 MT/month</td>
            </tr>
            <tr>
              <td>Packing</td>
              <td>
                <ul>
                  <li>Bulk</li>
                  <li>Netted Bag, 20-25 pcs/bag</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Max 40 feet HC Container</td>
              <td>± 26 MT</td>
            </tr>
            <tr>
              <td>Max 20 feet HC Container</td>
              <td>± 17 MT</td>
            </tr>
            <!-- <tr>
            <td>HS Code</td>
            <td>08011910</td>
          </tr> -->
            <tr>
              <td />
              <td />
            </tr>
            <!-- <tr>
            <td>Support</td>
            <td>
              <p class="mb-2">+012 345 6789</p>
              <p class="mb-0">support@example.com</p>
            </td>
          </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- end advertisement section -->
<style>
  /* -----------------------------------------------------------------------------

# About Styles

----------------------------------------------------------------------------- */
  a.video-play-btn {
    position: absolute;
    background-color: #f28123;
    color: #051922;
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 80px;
    border-radius: 50%;
    font-size: 40px;
    padding-left: 5px;
    display: block;
    z-index: 2;
    top: 50%;
    margin-top: -45px;
    -webkit-box-shadow: 0 0 20px #adadad;
    box-shadow: 0 0 20px #adadad;
    left: 50%;
    margin-left: -45px;
  }

  .abt-bg {
    /* background-image: url(../assets/images/project/coconutsemihuskthree.jpg); */
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    /* border-top-right-radius: 10px;
  border-bottom-left-radius: 10px; */
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  .abt-bg img {
    /* background-image: url(../assets/images/project/coconutsemihuskthree.jpg); */
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
  }

  .abt-bg:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    background-color: #051922;
    opacity: 0.3;
  }

  .abt-section .abt-text {
    padding: 50px;
    padding-left: 30px;
  }

  .abt-text p {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 10px;
  }

  .abt-text p.top-sub {
    opacity: 0.8;
    margin-bottom: 10px;
  }

  .abt-text p:last-child {
    margin-bottom: 0;
  }

  /*** Facts & Visiting Hours ***/
  .facts {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url(../assets/zoo/img/bg-1.jpg) center center no-repeat;
    background-size: cover;
  }

  .visiting-hours {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url(../assets/images/project/coconutsemihuskone.jpg) center center
        no-repeat;
    background-size: cover;
  }

  .visiting-hours .list-group-item {
    display: flex;
    justify-content: space-between;
    color: var(--light);
    background: rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.15);
  }

  .visiting-hours .table {
    color: var(--light);
    background: rgba(0, 0, 25, 0.15);
  }

  .visiting-hours .table td {
    padding: 0.5rem 1rem;
    border-color: rgba(0, 0, 0, 0.15);
    border-width: 1px;
  }

  .visiting-hours .table tr:last-child td {
    border: none;
  }
</style>
